export default __webpack_public_path__ + "static/media/ThumbExample.c9a29c41.jpg";